import { Controls } from "@vidstack/react";
import { AppliedFilters } from "../Filter/AppliedFilters";
import { useGameStore } from "../../../store";
import { VideoSidebar } from "../../../types";
import { CreateButtonComponent } from "../Create/CreateButtonComponent";

interface VideoPlayerControlsProps {
	show: boolean;
	fullscreen: boolean | undefined;
	onShowChange: (show: boolean) => void;
}

export function VideoPlayerControls({ show, fullscreen, onShowChange }: VideoPlayerControlsProps) {
	const { sidebar, setSidebar, gameData } = useGameStore();

	return (
		<Controls.Root className="vds-controls">
			<Controls.Group className="vds-controls-group top" style={fullscreen && sidebar && show ? { width: "calc(100% - 420px)" } : {}}>
				<div className="appliedFilters-container">
					<AppliedFilters />
				</div>
				{fullscreen && (
					<div
						className="showMenuButton"
						onClick={() => {
							if (sidebar && show) {
								onShowChange(false);
							} else {
								onShowChange(true);
							}
							if (!sidebar) {
								setSidebar(VideoSidebar.EventList);
							}
						}}
					>
						<span className="icon-new icon-video-list icon-20" />
					</div>
				)}
			</Controls.Group>
			<div className="vds-controls-spacer" />
			{
				<Controls.Group className="vds-controls-group bottom">
					<CreateButtonComponent
						clipsAllowed={gameData?.permissions.useClips || false}
						show={show}
						onShowChange={onShowChange}
						sidebar={sidebar}
						fullscreen={fullscreen ?? false}
					/>
				</Controls.Group>
			}
		</Controls.Root>
	);
}
